import {
  Component,
  ElementRef,
  input,
  model,
  output,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input-buscador',
  imports: [FormsModule],
  templateUrl: './input-buscador.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './input-buscador.css',
})
export class InputBuscador {
  private readonly inputRef = viewChild<ElementRef<HTMLInputElement>>('inputBusqueda');

  placeholder = input<string>('Buscar...');
  valorAntesDeCambio?: string;
  valor = model<string>('');
  presionaEnter = output<void>();
  emitirBusqueda() {
    if (this.valorAntesDeCambio !== this.valor()) {
      this.valorAntesDeCambio = this.valor();
      this.presionaEnter.emit();
    }
  }
  reset() {
    this.valor.set('');
    this.valorAntesDeCambio = undefined;
  }
  /** Enfoca el input y selecciona su contenido para poder seguir escaneando. */
  focus() {
    const input = this.inputRef()?.nativeElement;
    if (!input) return;
    input.focus?.();
    input.select?.();
  }
}
